import { Datipreventivo } from "../model/datipreventivo";
import { Lead } from "../model/lead";

export class DatiDual {
    public static dati(): Datipreventivo {
        return {
            id_comodity: 3,
            lead: new Lead(),
            component:null,
            datiextra: [
                {
                    idDato: 1,
                    tipodato: 3, //string
                    lstopzione: [],
                    descrizione: "dato a cazzo annuo",
                    valore: "0"
                },
            ]

        };
    }
}



// WEBPACK FOOTER //
// ./src/app/archiviodatipreventivo/dati-dual.ts